<div class="inbuilt-donut-v2-wrapper">
  <div class="donut-chart" id="d">
    @if (donutPanels.length > 0) {
    <div class="row donut-panels-container">
      @for (panel of donutPanels; track panel; let i = $index; let isLast = $last) {
      <div class="donut-panel-wrap" [ngClass]="getPanelLayoutClass(panel.element)">
        <div class="donut-panel-header" [class.no-border-bottom]="panel.header === 'default'">
          <span>{{ panel.header === 'default' ? '' : panel.header }}</span>
          @if (isJSONeditorEnabled) {
          <span class="json-editor-icon">
            <mat-icon title="Edit Panel JSON" (click)="openJSONeditorForPanel(panel.element)">create</mat-icon>
            <mat-icon class="ms-1" title="Delete Report" (click)="deleteReport(panel.element)">delete</mat-icon>
          </span>
          }
        </div>
        <div class="donut-host-layout">
          <div class="donut-host-chart">
            @switch (isDonutVisual(panel.element)) { @case ('donut_chart') {
            <app-inbuilt-donut-chart
              [width]="getDonutChartWidth()"
              [height]="getDonutChartHeight()"
              [isInfraChart]="true"
              [showMiddleTitle]="false"
              [externalLabelScale]="getDonutExternalLabelScale()"
              [selectedYear]="''"
              [config]="config"
              [elementData]="panel.element"
              (chartReady)="onChartReady(i)"
              (seriesChange)="onPanelSeriesChange(i, $event)"
              (headingResolved)="onPanelHeadingChange(i, $event)"
              titleMiddle="Total"
            >
            </app-inbuilt-donut-chart>
            } @case ('speedometer') {
            <app-inbuilt-speedometer-v2 [config]="config" [elementData]="panel.element"> </app-inbuilt-speedometer-v2>
            } @case ('bar_chart') {
            <app-inbuilt-bar-chart-v2
              [config]="config"
              [elementData]="panel.element"
              (headingResolved)="onPanelHeadingChange(i, $event)"
            >
            </app-inbuilt-bar-chart-v2>
            } @case ('column_chart') {
            <app-column-chart-v2
              [config]="config"
              [elementData]="panel.element"
              (headingResolved)="onPanelHeadingChange(i, $event)"
            >
            </app-column-chart-v2>
            } @case ('metrics') {
            <app-inbuilt-matrix [config]="config" [elementData]="panel.element"> </app-inbuilt-matrix>
            } @case ('table') {
            <app-inbuilt-table-v2 [config]="config" [elementData]="panel.element"> </app-inbuilt-table-v2>
            } @case ('drill_down_matrix') {
            <app-inbuilt-drill-down-matrix [config]="config" [elementData]="panel.element">
            </app-inbuilt-drill-down-matrix>
            } @case ('parent_child_table') {
            <app-parent-child-table [config]="config" [elementData]="panel.element"> </app-parent-child-table>
            } @case ('stack_chart') {
            <app-inbuilt-stack-chart
              [config]="config"
              [elementData]="panel.element"
              (headingResolved)="onPanelHeadingChange(i, $event)"
            >
            </app-inbuilt-stack-chart>
            } @default {
            <div class="donut-state">
              Visual type is not supported yet.
            </div>
            } }
          </div>
          @if (panel.legendData.length > 0) {
          <div class="donut-host-legend">
            @for (slice of panel.legendData; track slice) {
            <div class="legend-row">
              <span class="legend-swatch" [style.backgroundColor]="slice.color"></span>
              <div class="legend-text">
                <div class="legend-label">{{ slice.label ? slice.label.split('_').join(' ') : '' }}</div>
              </div>
            </div>
            }
          </div>
          }
        </div>
      </div>
      }
    </div>
    }
  </div>

  <app-modal
    [maximizable]="true"
    [inViewport]="true"
    #modalEditJSON
    class="modal-demo edit-json-popup"
    (closeModal)="hidepopup('edit')"
  >
    <ng-container class="app-modal-header">Visual Editor</ng-container>
    <ng-container class="app-modal-body">
      @if (isJSONeditorPopupOpen) {
      <app-inbuilt-editor
        [initialJson]="activePanelElement?.element_json || {}"
        [queryCode]="activePanelElement?.Constructed_Query || ''"
        (jsonTextChange)="onJsonEditorTextChange($event)"
      ></app-inbuilt-editor>
      }
    </ng-container>
  </app-modal>
</div>
